<template>
  <div class="form-group w-100">
    <label for="input-global">{{ propLabel }}<strong class="input-live-help">{{ propRequired ? ' *' : '' }}</strong></label>
    <b-form-radio-group v-model="selected"
                        :options="propOptins"
                        name="radio-options" />
  </div>
</template>

<script>
  // Imports

  export default ({
    name: "RadioGlobal",
    props: {
      propLabel: {type: String, default: ''},
      propDataPropriedade: {type: String, default: null},
      propRequired: {type: Boolean, default: false},
      propOptins: {type: Array, default: null}
    },
    data () {
      return {
        selected: null,
      }
    },
    computed: {

    },
    watch: {
      selected () {
        this.handleChange()
      }
    },
    async created  () {
 
    },
    methods: {
      handleChange () {
        this.$emit('setInputValue', this.selected, this.propDataPropriedade)
      }
    }
  })
</script>